module.exports = __webpack_public_path__ + "static/media/silver.867643f2.svg";